import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useUniqueOptionsDataGridFilter } from '../../../../common/DataGrid/filters/useUniqueOptionsDataGridFilter.jsx';
import { useYesNoStringDataGridFilter } from '../../../../common/DataGrid/filters/DataGridFilters.jsx';

const RoomsTable = ({ rooms, onDetailClick, onDelete }) => {
  const { t } = useTranslation();

  const roomsOptionsFilterProps = useUniqueOptionsDataGridFilter(
    'title',
    rooms,
  );
  const schoolDepartmentOptionsFilterProps = useUniqueOptionsDataGridFilter(
    'department_name',
    rooms,
  );
  const departmentRoomBooleanFilterProps =
    useYesNoStringDataGridFilter('department_room');

  const columns = [
    {
      title: t('Miestnosť'),
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      ...roomsOptionsFilterProps,
    },
    {
      title: t('Pracovisko'),
      dataIndex: 'department_name',
      key: 'department_name',
      ellipsis: true,
      width: '60%',
      ...schoolDepartmentOptionsFilterProps,
    },
    {
      title: t('Katedrová'),
      key: 'department_room',
      dataIndex: 'department_room',
      ...departmentRoomBooleanFilterProps,
      render: (val) => {
        const yesLike = val === 'Yes';
        return yesLike ? t('Áno') : t('Nie');
      },
    },
  ];

  return (
    <DataGrid
      rowKey={(room) => room.id}
      columns={columns}
      dataSource={rooms || []}
      permissionsBasic={'rooms'}
      uniqueTableId={'rooms-table'}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
    />
  );
};

RoomsTable.propTypes = {
  rooms: PropTypes.array,
  onDelete: PropTypes.func,
  onCreateClick: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default RoomsTable;
